import Icon from '../components/Icon.vue'

Icon.register({
  motorcycle: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M512.9 192c69.6 0.5 126.5 57.3 127.2 126.9 0.6 71.6-57.6 129.8-129.2 129.1-69.6-0.6-126.3-57.5-126.8-127.1-0.3-39.3 17.2-74.5 44.8-98.2l-12.5-20.8c-38.7 31.3-58.3 77.9-56.2 125 0.6 13.7-10.3 25.1-24 25.1h-84.2c-14.3 55.2-64.4 96-124 96-71.7 0-129.6-58.9-128-131 1.6-67.4 55.9-122.5 123.2-124.9 14.4-0.5 28.3 1.3 41.3 5.2l11.3-20.5c-9.1-13.9-23.3-24.8-47.8-24.8h-56c-13.1 0-23.8-10.5-24-23.5-0.3-13.5 11-24.5 24.5-24.5h55.5c55 0 82.2 16.9 99.9 40h153.7l-19.2-32h-66.4c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h80c8.4 0 16.2 4.4 20.6 11.6l22.8 38 37.5-41.7c4.5-5 11-7.9 17.8-7.9h45.3c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24h-82.4l32.9 54.9c13.3-4.6 27.5-7 42.4-6.9zM128 400c32.7 0 60.9-19.8 73.3-48h-81.3c-18.2 0-29.8-19.6-21-35.6l41.5-75.4c-4.1-0.7-8.3-1-12.5-1-44.1 0-80 35.9-80 80s35.9 80 80 80zM591.9 324.4c2.4-46.1-34.3-84.4-79.9-84.3-5.4 0-10.7 0.5-15.9 1.6l48.6 80.9c4.5 7.6 2.1 17.5-5.5 22l-13.7 8.2c-7.6 4.5-17.5 2.1-22-5.5l-49.4-82.4c-13.7 14.3-22.1 33.7-22.1 55.1 0 45.6 38.3 82.4 84.4 79.9 40.5-2.1 73.3-34.9 75.5-75.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/motorcycle.js
// module id = 1587
// module chunks = 0